export class Login{
    
    public UserName:string | undefined = undefined;
    public Password:string | undefined = undefined;
    public PermissionMap:Map<any,any> | undefined = undefined;
    public Token:string | undefined = undefined;
    public HasError:boolean = false;
}